import React from 'react';
import {shareContent} from "@/utils/helpers.js";

// Success Component
export const RegistrationSuccess = ({uuid, eventDetails, selfiePreview, name}) => {
    const handleShare = async () => {
        const shareUrl = `${window.location.origin}/${uuid}/register`;
        await shareContent(
            `${eventDetails?.title || 'Event'} Photos`,
            'Get all your photos from the event',
            shareUrl
        );
    };

    return (
        <div className="registration-result-container">
            <div className="avatar-container">
                <div className="avatar">
                    <img src={selfiePreview} alt="Your selfie"/>
                    <div className="avatar-verified">
                        <i className="fa fa-check"></i>
                    </div>
                </div>
            </div>

            <h2 className="result-title success">Registration Success!</h2>

            <p className="result-message">
                <b>{name.toUpperCase()}</b>, We'll notify you once the photographer has uploaded your photos.
            </p>

            <div className="card share-card">
                <div className="card-content">
                    <div className="text-center">
                        <h3 className="share-title">Share with Friends & Family</h3>

                        <p className="share-description">
                            Let your friends and family know that they can also get their pictures on WhatsApp.
                        </p>
                        <div className="center">
                            <button className="button button-icon" onClick={handleShare}>
                                <i className="fa fa-share"></i>Share
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};